module.exports = __webpack_public_path__ + "static/media/whyus3.5bfc0c20.png";